const routes = {
  path: '/esf-manager',
  component: () => import('@/components/layout/index.vue'), 
  alwaysShow: true,
  meta: {
    title: '租售管理',
    icon: 'iconshujuzhongxin',
    permission: 'esf'
  },
  children: [
    {
      path: 'sale-list',
      name: 'SaleList',
      component: () => import('@/views/esf/houseManager/saleList'),
      meta: {
        title: '出售房源',
        permission: 'esf.sale-list'
      }
    },
    {
      path: 'sale-detail',
      name: 'SaleDetail',
      component: () => import('@/views/esf/houseManager/detail'),
      hidden: true,
      meta: {
        title: '出售房源详情',
        permission: ''
      }
    },
    {
      path: 'visitor-manager',
      name: 'VisitorManger',
      component: () => import('@/views/esf/visitSourceManage/index'),
      meta: {
        title: '客源管理',
        permission: 'esf.customer'
      }
    },
    {
      path: 'rent-list',
      name: 'RentList',
      component: () => import('@/views/esf/houseManager/rentList'),
      meta: {
        title: '出租房源',
        permission: 'esf.rent-list'
      }
    }
  ]
}
export default routes;